import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CelebrationRoundedIcon from "@mui/icons-material/Celebration";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import { useNavigate } from "react-router-dom";

const ManageSubscriptionResult = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #f8fbff 0%, #eef7ff 50%, #ffffff 100%)",
        py: 5,
      }}
    >
      <Container maxWidth="sm">
        <Card
          elevation={8}
          sx={{
            borderRadius: 5,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              bgcolor: "success.main",
              color: "white",
              py: 5,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CheckCircleRoundedIcon sx={{ fontSize: 90 }} />
          </Box>

          <CardContent sx={{ p: 5 }}>
            <Stack spacing={3} alignItems="center">
              <CelebrationRoundedIcon
                color="warning"
                sx={{ fontSize: 45 }}
              />

              <Typography
                variant="h4"
                fontWeight={700}
                textAlign="center"
              >
                Subscription Activated!
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                textAlign="center"
              >
                Your payment method has been added successfully and your free
                trial is now active.
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
              >
                You now have full access to all premium features during your
                trial period. We'll notify you before your trial ends.
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  bgcolor: "success.50",
                  border: "1px solid",
                  borderColor: "success.light",
                  borderRadius: 3,
                  p: 2.5,
                }}
              >
                <Typography
                  variant="subtitle2"
                  color="success.dark"
                  fontWeight={700}
                  gutterBottom
                >
                  What's Next?
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  • Explore premium features
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  • Manage your subscription anytime
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  • Update your payment method whenever needed
                </Typography>
              </Box>

              <Button
                size="large"
                variant="contained"
                startIcon={<DashboardRoundedIcon />}
                onClick={() => navigate("/settings/subscription")}
                sx={{
                  mt: 2,
                  px: 5,
                  py: 1.5,
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Close
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ManageSubscriptionResult;